import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { CompanyInsightsService } from 'src/app/_services/company-insights.service';
import { GlobalService } from 'src/app/_services/global.service';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import { PersonSearchService } from 'src/app/_services/person-search.service';
declare const clevertap;

@Component({
    selector: 'app-webbtree-comapnylist-footer',
    templateUrl: './webbtree-comapnylist-footer.component.html',
    styleUrls: ['./webbtree-comapnylist-footer.component.scss'],
    standalone: false
})
export class WebbtreeComapnylistFooterComponent implements OnInit {

  compareCompanyFirst: UntypedFormControl = new UntypedFormControl('Add Company');
  compareCompanySecond: UntypedFormControl = new UntypedFormControl('Add Company');
  companyoneDetails: any;
  companytwoDetails: any;
    @Output() buttonClicked = new EventEmitter<boolean>();
    @Output() footerStickOnSearchCompany = new EventEmitter<boolean>();

  constructor(private companyInsightsService: CompanyInsightsService, private router: Router, private localStorageService: LocalStorageService,
    private personSearchService: PersonSearchService) { }

  ngOnInit() {
    this.companyInsightsService.companyCompareDetails.subscribe(res=>{this.getcompanyPatch(res)});
  }

  getcompanyPatch(response) {
    this.companyoneDetails = response.companyone[0];
    this.companytwoDetails = response.companytwo[0];
    if(response.companyone.length && response.companyone[0].id)
      this.compareCompanyFirst.patchValue(response.companyone[0].name);
     if(response.companytwo.length && response.companytwo[0].id)
     this.compareCompanySecond.patchValue(response.companytwo[0].name);

      if(response.companyone.length && response.companyone[0].id || response.companytwo.length && response.companytwo[0].id){
        this.footerStickOnSearchCompany.emit(true);
      }else{
         this.footerStickOnSearchCompany.emit(false);
      }
  }

  clearCompanyName(type) {
    if(type == 'companyone') {
      this.compareCompanyFirst.patchValue('Add Company');
      this.companyInsightsService.companycompareone = [];
      this.localStorageService.setItem('companyOneId', null);
    } else if(type == 'companytwo') {
      this.compareCompanySecond.patchValue('Add Company');
      this.companyInsightsService.companycomparetwo = [];
      this.localStorageService.setItem('companyTwoId', null);

    }

    if ((!this.companyInsightsService.companycompareone || this.companyInsightsService.companycompareone.length === 0)&&(!this.companyInsightsService.companycomparetwo || this.companyInsightsService.companycomparetwo.length === 0)) {
       this.buttonClicked.emit(false);  // send 'true' to parent
    }
    const payload = {
      companyone: this.companyInsightsService.companycompareone,
      companytwo: this.companyInsightsService.companycomparetwo
    }

    this.companyInsightsService.sendCompanyCompareDetails(payload);
  }

  redirectTOCompanyCompare() {

    this.localStorageService.setItem('companyOneId',this.companyInsightsService.companycompareone[0].id )
    this.localStorageService.setItem('companyTwoId',this.companyInsightsService.companycomparetwo[0].id );
    const payload = {
      companies: [this.companyInsightsService.companycompareone[0].name, this.companyInsightsService.companycomparetwo[0].name],
      id: [this.companyInsightsService.companycompareone[0].id, this.companyInsightsService.companycomparetwo[0].id]
    }
    this.setCompanyInsightsHistory(payload, 'company comparison');
    const companyInsightsParams = {
      "User ID": this.localStorageService.getItem('userdata').userid,
      "Company Name 1": this.companyInsightsService.companycompareone[0].name,
      "Company Name 2": this.companyInsightsService.companycomparetwo[0].name,
      "Source": "Listing"
    }
    clevertap.event.push("Company Comparison Performed", companyInsightsParams);
    this.router.navigateByUrl('/company-compare');
    }

  setCompanyInsightsHistory(data, selectionType: string) {
    const payload = {
      ...((selectionType === 'company') && {
        companies: data.companies,
        companyids:
          data.id
      }),
      ...((selectionType === 'company comparison') && {
        companies: data.companies,
        companyids:
          data.id
      }),
      module: GlobalService.HISTORY_MODULE.COMPANY_COMPARISON

    }
    this.personSearchService.setInsightsHistory(payload).subscribe((res) => {
      if (res) {
        this.localStorageService.setItem('companyInsightsHistoryId', res.talentdiscoveryhistoryid);
      }
    });
  }
}


